<template>
    <IntegrationsSettingsLayout :disable-store-card="integration.state === IntegrationState.MissingConfig"
                                no-gutters
    >
        <IntegrationSettingsCard icon="fas fa-cogs"
                                 :title="__('general.api.settings')"
                                 :description="__('actions.manage_thing', {thing:__('general.api.settings')})"
        >
            <template v-slot:body>
                <form>
                    <div class="row">
                        <div class="col-md-6">
                            <FormGroupNew :label="__('general.api.user')"
                                          :description="__('actions.please_enter_thing', {thing:__('general.api.the_user')})"
                                          :error="configs.errors.ph_user"
                                          :required="requiredFields.includes('ph_user')"
                            >
                                <input type="text" autocomplete="false" class="form-control" v-model="configs.ph_user">
                            </FormGroupNew>
                        </div>
                        <div class="col-md-6">
                            <FormGroupNew :label="__('general.api.password')"
                                          :description="__('actions.please_enter_thing', {thing:__('general.api.the_password')})"
                                          :error="configs.errors.ph_sec"
                                          :required="requiredFields.includes('ph_sec')">
                                <PasswordInput v-model="configs.ph_sec"/>
                            </FormGroupNew>
                        </div>
                        <div class="col-md-6">
                            <FormGroupNew :label="__('general.api.host')"
                                          :description="__('actions.please_enter_thing', {thing:__('general.api.the_host')})"
                                          :error="configs.errors.ph_api_url"
                                          :required="requiredFields.includes('ph_api_url')"
                            >
                                <input type="text" autocomplete="false" class="form-control" v-model="configs.ph_api_url">
                            </FormGroupNew>
                        </div>
                        <div class="col-md-6">
                            <FormGroupNew :label="__('general.api.version')"
                                          :description="__('actions.please_enter_thing', {thing:__('general.api.the_version')})"
                                          :error="configs.errors.ph_api_version"
                                          :required="requiredFields.includes('ph_api_version')">
                                <input type="text" autocomplete="false" class="form-control" v-model="configs.ph_api_version"/>
                            </FormGroupNew>
                        </div>
                    </div>
                </form>

                <ProHandelApiTest :configs="configs" :test-required="integration.state === IntegrationState.MissingConfig"/>
            </template>

            <template v-slot:footer>
                <SaveAndEnableButton :show-enable-variant="integration.state === IntegrationState.MissingConfig"
                                     :disabled="!configs.isDirty"
                                     @click="saveUserSettings"
                />
            </template>
        </IntegrationSettingsCard>
    </IntegrationsSettingsLayout>
</template>

<script>
import IntegrationsSettingsLayout from "@layouts/IntegrationsSettingsLayout.vue";
import IntegrationSettingsCard from "@components/Integrations/IntegrationSettingsCard.vue";
import SaveAndEnableButton from "@components/Integrations/SaveAndEnableButton.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import PasswordInput from "@components/Form/PasswordInput.vue";
import ProHandelApiTest from "@components/Integrations/ProHandel/ProHandelApiTest.vue";
import {IntegrationState} from "@generated/integrationState";

export default {
    components: {
        IntegrationsSettingsLayout,
        ProHandelApiTest,
        PasswordInput,
        FormGroupNew,
        SaveAndEnableButton,
        IntegrationSettingsCard
    },

    props: {
        integration: Object,
        formData: Object,
        stores: Array,
        enabledStores: Array,
        requiredFields: Array
    },

    data() {
        return {
            configs: this.$inertia.form(this.formData),
        }
    },

    methods: {
        saveUserSettings() {
            this.configs.post(this.$route('integration.config', this.integration.code))
        },
    },

    computed: {
        IntegrationState() {
            return IntegrationState
        }
    },
}
</script>
